import React from 'react';

const PrivacyPolicyKO = () => {
  return (
    <>
      ‘㈜블렌딩’ (이하 ‘회사’라 합니다)은 모바일 및 인터넷 상에서의 개인정보 보호를 매우 중요하게 생각하고 있으며,
      이용자가 ㈜블렌딩이 제공하는 모바일 서비스 ‘뮤빗’ (이하 ‘서비스’라 합니다)를 이용함에 있어 ㈜블렌딩에게 제공한
      개인정보가 보호 받을 수 있도록 최선을 다하고 있습니다.
      <br />
      <br />
      본 개인정보취급방침은 정부의 법률및 지침 변경이나 (주)블렌딩 내부방침 변경 등으로 인하여 수시로 변경될수 있으며
      (주)블렌딩은 변경사항이 있을 경우 즉시 관련 내용을 APP서비스 &gt; 설정, 홈페이지 초기 화면에 게시된
      개인정보취급방침에 반영하고 있습니다.
      <br />
      <br />
      <b>1. 개인정보 수집</b>
      <br />
      회사는 이용자 (이하 ‘회원’라 합니다)에게 서비스를 제공하기 위해 특정 정보를 요구합니다.
      <br />
      회원은 검색, 차트 보기 , 아티스트 채널과 같은 일부 서비스 기능을 사용하기 위해 계정을 만들 필요가 없습니다. 회원이
      계정을 만들기로 선택한 경우 회사가 서비스를 제공할 수 있도록 일부 개인 데이터를 회사에 제공해야 합니다. 계정을
      만들 때 회원은 Google, Facebook 또는 Twitter와 같은 다른 서비스의 계정으로 서비스에 가입하거나 서비스에 연결할 수
      있습니다.
      <br />
      또한 회사는 회원에게 편리하고 다양한 서비스를 제공하기 위하여 회원으로 부터 수집한 개인정보를 이용하여 회사가
      제공하는 각종 서비스를 전자우편, 푸시 방법으로 광고 또는 마케팅 활동을 수행할 수 있습니다. 이 경우 회원은 언제든지
      전자우편 등을 통해 원치 않는 서비스를 거절할 수 있습니다.
      <br />
      <br />
      <b>1.1 개인정보 수집 방법</b>
      <br />
      회원가입 시 회사의 서비스 이용약관에 대한 &quot;동의&quot; 버튼을 선택하여 클릭하시면 동시에 본 개인정보
      보호정책에도 동의한 것으로 간주하고 이에 따라 회사는 가입양식에 입력한 사항을 바탕으로 개인정보를 수집합니다.
      <br />
      회사는 서비스 제공을 위해 다음과 같은 방법으로 개인정보를 수집합니다.
      <ul>
        <li>서비스의 회원가입 및 이용과정에서 이용자로부터 직접 수집</li>
        <li>회사의 제3자 및 비즈니스 파트너가 제공 한 정보</li>
        <li>1:1 상담 문의 및 이용자가 직접 입력</li>
      </ul>
      <b>2. 수집하는 개인정보의 항목</b>
      <br />
      <br />
      <b>2.1 기본 계정 정보</b>
      <br />
      회사는 계정 생성, 로그인 서비스, 원활한 고객 상담 및 사용 연령을 확인하기 위해 아래의 개인정보를 수집 및
      이용합니다.
      <ul>
        <li>뮤빗 계정으로 로그인 : 이용자 ID(이메일), 비밀번호</li>
        <li>페이스북 계정으로 로그인 (이용자가 공개 설정한 경우에 한함) : 페이스북 ID, 이메일, 닉네임</li>
        <li>구글플러스 계정으로 로그인 : 구글플러스 ID, 이메일, 닉네임</li>
        <li>트위터 계정으로 로그인: 트위터 ID, 이메일, 닉네임</li>
      </ul>
      연령확인 또는 관련 법률 준수를 위해 본인인증이 필요한 경우, 이용자의 별도 동의하에 아래의 정보를 수집할 수
      있습니다.
      <ul>
        <li>암호화된 개인식별정보 (CI)</li>
        <li>중복가입확인 정보 (DI)</li>
      </ul>
      기타 서비스 이용과정에서 아래와 같은 정보들이 생성되어 수집될 수 있습니다.
      <ul>
        <li>동영상 선택, 시청기록 및 검색어 등 뮤빗 서비스 관련 활동</li>
        <li>이벤트 및 고객 문의 처리 과정에서 이메일 주소 및 경품 배송 정보 추가 수집 등</li>
      </ul>
      <b>2.2 기술적 정보</b>
      <br />
      회사는 회원의 계정을 안전하고 안정적으로 설정하고 유지 관리하고 서비스를 운영하기 위해 응용 프로그래밍 인터페이스
      (APIs)와 같은 기술을 사용하여 웹 사이트, 응용 프로그램 및 기타 사용자들이 아래와 같은 특정 유형의 정보를 수집 할
      수 있도록 정보를 제공합니다.
      <br />
      로그 데이터:
      <br />
      회사는 회원이 계정을 만들지 않은 경우에도 회원이 서비스와 상호 작용할 때 &quot;로그 데이터&quot;로 지칭되는 정보를
      수집합니다. 이 로그 데이터에는 회원의 IP 주소, 기기식별번호 (UUID), 운영 체제, 이동통신사 및 기기 정보 (기기 언어
      설정 포함), 광고 식별자 (GAID/ IDFA)과 같은 정보가 포함됩니다.
      <br />
      회사는 회원이 제공하는 정보와 데이터 및 제3 자로부터의 로그 데이터를 사용하여 회원이 관심을 가질 수 있는 주제,
      나이 및 사용 언어에 대해 추측합니다. 이를 통해 서비스를 더 효과적으로 설계 할 수 있습니다.
      <br />
      링크:
      <br />
      회사는 서비스를 운영하기 위해 다른 웹 사이트에서 회원이 서비스 영상 클립의 공유 링크와 상호 작용하는 방식을
      추적합니다.
      <br />
      위치 정보:
      <br />
      회사는 회원의 위치에 대한 정보 (예: IP 주소 및 거주 국가)를 수집 할 수 있으며, 해당 정보를 사용하여 회원의 위치를
      알아야 서비스 및 기능을 사용자 정의 할 수 있습니다. 서비스에 액세스하여 사용함으로써 회원은 위치 정보의 수집 및
      사용에 동의합니다.
      <br />
      회사는 서비스 제공 및 개선을 지원하는 비즈니스 파트너 및 서비스 제공 업체 (예: Google Analytics)로부터 회원이
      서비스를 사용하는 방법에 대한 정보를 받습니다.
      <br />
      아래는 회사의 서비스 제공 업체 목록입니다.
      <ul>
        <li>Google Analytics</li>
        <li>Firebase</li>
        <li>Facebook Analytics</li>
        <li>Amazon Web Service</li>
      </ul>
      <b>3. 사용목적</b>
      <br />
      회사는 수집한 정보를 다음과 같은 목적으로 이용합니다.
      <ul>
        <li>이용자가 서비스를 원활히 이용할 수 있도록 돕기 위해</li>
        <li>서비스 이용에 따른 이용자 식별 및 부정 이용 방지를 위해</li>
        <li>서비스 이용에 관한 통계 데이터를 작성하기 위해</li>
        <li>서비스 개선에 필요한 설문조사 및 분석을 위해</li>
        <li>이용자로부터 문의가 있을 때 본인 여부를 확인하고 문의사항에 대응하기 위해</li>
        <li>중요한 공지사항 등을 필요에 따라 공지(푸시알림, 메일, 온라인 메시지 채널) 하기 위해</li>
        <li>이벤트 등 광고성 정보(푸시알림, 메일, 온라인 메시지 채널)의 전달을 위해</li>
        <li>회사가 제공하는 맞춤 서비스, 정보 (광고 포함) 전달을 위해</li>
      </ul>
      ※ 회사는 온라인 맞춤형 광고성 정보 전송을 위해 최소한의 행태정보를 수집하고 있습니다. 광고식별자를 통해 수집한
      행태정보는 맞춤형 광고성 정보 제공을 위해 최대 6개월간 보관 후 파기하며, 파기 시에는 복구·재생할 수 없는 기술적인
      방법을 사용합니다. 회원은 언제든지 맞춤형 광고를 차단할 수 있으며, 차단한 경우 더 이상 맞춤형 광고가 노출되지
      않습니다.
      <br />
      <br />
      <b>행태정보 수집 거부 방법</b>
      <ul>
        <li>안드로이드폰 - Google 설정 → 광고 → 광고 맞춤설정 선택 또는 해제</li>
        <li>아이폰 - 설정 → 개인정보보호 → 광고 → 광고 추적 제한</li>
      </ul>
      <b>4. 개인 정보의 공유</b>
      <br />
      회사는 원칙적으로 이용자의 개인정보를 이용자 사전 동의 없이 외부에 제공하지 않습니다. 다만 아래의 경우에는 예외로
      합니다.
      <ul>
        <li>원활한 서비스 제공을 지원하는 제휴사 및 서비스 제공 업체</li>
        <li>
          기술 인프라 제공 업체 (예: 서버) 또는 엔지니어링 또는 기타 지원, 기술 서비스 및 기능 개발자, 연구 및 분석 회사
          및 이메일 제공 업체와 같이 회사를 대신하여 서비스를 수행하는 회사 (제3자 및 계열사 모두 포함)
        </li>
        <li>이용자들이 사전에 동의한 경우</li>
        <li>
          관련 법률 및 규정에 의해 공개되어야 하고, 그러한 공유가 법률에 따라 허용되거나, 불법 행위, 사기로 의심되는
          행위에 대한 조사, 예방 또는 조처를 하기 위해 합당하게 필요하다고 믿는 경우, 개인의 신체 안전에 대한 잠재적
          위협, 본 개인정보처리방침 또는 이용약관 위반
        </li>
        <li>제휴사의 비즈니스 총체적 혜택 및 운영 목적을 위해</li>
      </ul>
      회사는 사용자 데이터를 광고 기술 제공업체와 공유합니다. 이러한 광고 기술 제공업체는 이용자 형태 정보를 수집하고
      광고 개인화 및 측정을 위해 사용자에 대한 데이터를 사용할 수 있습니다.
      <br />
      아래는 회사의 광고 기술 제공업체 목록이며 각 국가에 따라 제공 업체가 다를수 있습니다.
      <ul>
        <li>Google</li>
        <li>스마트미디어렙 (주)</li>
        <li>Facebook</li>
        <li>IGAWorks</li>
        <li>Tapjoy</li>
        <li>Buzzvil</li>
        <li>Vungle</li>
        <li>AppLovin</li>
        <li>PubMatic</li>
        <li>Liftoff</li>
        <li>adPOPcorn</li>
        <li>MoPub</li>
      </ul>
      <b>4.1 공개 정보</b>
      <br />
      회원이 계정을 만들 때 닉네임 및 프로필 이미지 정보는 항상 공개되며 서비스의 다른 회원과 공유됩니다. 회원이
      아티스트 커뮤니티에서 게시물을 올리면 해당 내용이 공개됩니다. 다른 회원의 게시물에 게시된 모든 댓글도 공개됩니다.
      회원은 본인이 서비스를 통해 제공하는 회원의 정보에 대한 책임을 다 가지며, 공개하는 정보, 특히 민감한 정보에 대해
      신중해야 합니다.
      <br />
      <br />
      <b>5. 어린이 개인 정보</b>
      <ol>
        <li>
          EU GDPR 개정 시행 국가에서 16세 미만의 사람으로부터 고의로 개인 데이터를 수집하거나 요청하지 않습니다. 최소
          연령 미만인 경우 서비스 등록을 시도하거나 자신에 관한 개인 정보를 회사에 보내지 마십시오. 필요한 최소 연령
          미만의 어린이로부터 개인 데이터를 수집했다는 사실을 알게 되면 최대한 빨리 해당 정보를 삭제합니다. 최소 연령
          미만의 어린이가 개인 정보를 제공했다고 생각하면 support@mubeat.tv 로 연락하십시오.
        </li>
        <li>
          각 국가별 개별 법률을 통하여 부모 등 법정대리인의 동의를 요구하는 아동 연령 기준을 만 13세까지 낮추어
          규정할수가 있습니다. 만 13세 미만 아동의 경우, 회원의 법정대리인이나 위임을 받은자 등 대리인을 통하여 하실 수
          있습니다. 이경우, 법정대리인은 회원의 모든 권리를 가집니다. 개인 정보의 수집 및 이용목적에 대하여 충분히
          숙지하고 부모 등의 법정대리인의 동의를 얻은 후에 회원가입을 신청해야합니다. 또한 부모 등 법정 대리인은 아동에
          대한 개인정보의 열람, 정정, 갱신을 요청하거나 회원가입에 대한 동의를 철회할 수 있으며 이러한 경우에 회사는
          지체 없이 필요한 조치를 취해야 합니다.
        </li>
      </ol>
      부모가 필요한 최소 연령 미만의 어린이가 개인 정보를 제공했다고 생각되는 경우 support@mubeat.tv 로 문의해 주십시오.
      <br />
      <br />
      <b>6. 회원의 권리와 그 행사방법</b>
      <br />
      회원은 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며 계정삭제를 요청할 수 있습니다. 계정
      설정 통해 회원은 회사에 제공한 다음 정보에 액세스하거나 편집하거나 때에 따라 삭제할 수 있습니다.
      <ul>
        <li>아이디 및 비밀번호</li>
        <li>이메일 주소</li>
        <li>프로필 이미지</li>
        <li>회원이 서비스에 업로드 한 텍스트, 이미지 및 링크를 포함한 커뮤니티 및 담벼락 게시물</li>
      </ul>
      위 정보 또는 기타 데이터의 정정·삭제를 원하는 회원은, 아래 정보를 support@mubeat.tv 로 보내 주시길 바랍니다.
      <ul>
        <li>뮤빗 이메일 주소 및 아이디</li>
        <li>문의 내용 및 구체적인 설명</li>
      </ul>
      서비스 변경에 따라 회원이 보고 업데이트하고 삭제할 수 있는 정보가 변경될 수 있습니다.
      <br />
      회원이 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지
      않습니다.
      <br />
      회사는 회원의 요청에 의해 해지 또는 삭제된 개인정보를 아래 “개인정보 보유 및 이용기간”에 명시된 바에 따라 처리하고
      그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
      <br />
      <br />
      <b>7. 개인정보의 보유 및 이용기간</b>
      <br />
      회원의 개인정보는 회사가 서비스를 제공하는 기간(이용기간) 또는 분쟁처리 기간(보유기간) 동안에 한하여 보유하고 이를
      활용하며 개인정보의 수집목적 또는 제공받은 목적을 달성한 이후에는 지체없이 재생불가능한 기술적인 방법을 사용하여
      개인정보를 파기하고 있습니다.
      <ul>
        <li>회원가입 정보의 경우, 회원 가입을 탈퇴하거나 회원에서 제명된 때</li>
        <li>(상거래) 대금지급 정보의 경우, 대금의 완제일 또는 채권소멸시효기간의 만료일</li>
        <li>상품배송 정보의 경우, 물품 또는 서비스가 인도되거나 제공된 때</li>
      </ul>
      단, 상법 등 법령의 규정에 의하여 보관의무가 규정되어 있거나 본인의 동의를 받았을 경우, 사전에 고지한 보유기간이
      경과하지 않은 경우, 소송이나 분쟁이 발생하거나 발생할 가능성이 있어 관련 개인정보의 보유가 법적 대응을 위하여
      필요한 경우 등에는 필요한 기간 동안 개인정보를 보유할 수 있습니다.
      <br />
      전자상거래 등에서의 소비자 보호에 관한 법률, 전자금융거래법, 통신비밀보호법 등 법령에서 일정기간 정보의 보관을
      규정하는 경우는 아래와 같습니다. 회사는 이 기간 동안 법령의 규정에 따라 개인정보를 보관하며, 본 정보를 다른
      목적으로는 절대 이용하지 않습니다.
      <ul>
        <li>
          전자상거래 등에서 소비자 보호에 관한 법률
          <br />
          계약 또는 청약철회 등에 관한 기록: 5년 보관
          <br />
          대금결제 및 재화 등의 공급에 관한 기록: 5년
          <br />
          소비자의 불만 또는 분쟁처리에 관한 기록: 3년 보관
        </li>
        <li>
          전자금융거래법
          <br />
          전자금융에 관한 기록: 5년 보관
        </li>
        <li>
          서비스 이용기록 : 통신비밀보호법
          <br />
          로그인 기록: 3개월
        </li>
      </ul>
      다만, 이 기간 동안의 개인정보 열람 및 이용은 해당 사유로 국한되며 그 후에도 계속 보유할 필요가 있을 경우에는
      회원에게 이러한 사실을 고지하고 그에 대한 동의를 받습니다.
      <br />
      일시적인 목적(이벤트, 설문조사 등)을 위하여 제공받는 것임을 밝히고 입력 받은 개인정보는 그 목적이 달성된 이후에는
      이용자 또는 회원의 의사에 따라 회원가입에 필요한 정보로 처리되거나 재생할 수 없는 방법에 의하여 디스크에서 완전히
      삭제하여 추후 열람이나 이용이 불가능한 상태로 처리됩니다.
      <br />
      단, 회원가입을 탈퇴하는 경우에도 해당 계정에 대한 서비스 내 게시물, 투표 등 서비스 이용 기록과 특정 이벤트에
      참여했다는 기록은 서비스 및 이벤트 운영에 대한 관리 및 리포팅 등의 사유로 보관될 수 있습니다. 탈퇴한 회원의 이벤트
      참여 데이터는 다음과 같은 방법으로 관리합니다.
      <ul>
        <li>회원가입 탈퇴 시 탈퇴한 회원는 이벤트 당첨에서 제외</li>
        <li>회원가입 탈퇴하더라도 투표 등 이벤트 참여에 대한 결과 기록은 삭제되지 않음</li>
      </ul>
      회원이 장기간 동안 회원으로서의 이용을 중단한 경우, 회사는 회원자격 정리기간을 정하여 서비스 화면 또는 전자메일을
      통해 일정기간 고지한 후 관련 회원의 이의 제기가 없을 경우 해당 회원의 회원자격을 중지하고, 이에 따라 관련된
      개인정보를 분리하여 보관 및 삭제할 수 있습니다.
      <br />
      <br />
      <b>8. 개인정보 파기절차 및 방법</b>
      <br />
      회사의 개인정보 파기절차 및 방법은 다음과 같습니다.
      <br />
      <br />
      <b>8.1 파기 절차</b>
      <br />
      본 개인정보처리방침의 요약된 수집 목적을 달성한 후, 사용자의 개인 정보는 &apos;7. 개인정보의 보유 및
      이용기간&apos;을 준수한 다음 내부 정책 및 관련 법률에 따라 파기합니다. 이러한 개인 정보는 법에서 요구하는 경우를
      제외하고는 보존 이외의 목적으로 사용되지 않습니다.
      <br />
      <br />
      <b>8.2 파기 방법</b>
      <br />
      종이에 출력된 개인정보는 분쇄기로 분쇄합니다. 전자적 파일 형태로 저장된 개인정보 기록은 재생할 수 없는 기술적
      방법을 사용하여 삭제합니다.
      <br />
      <br />
      <b>8.3 기타, 휴면 계정의 개인 정보 안내</b>
      <br />
      회사는 「국내 정보통신망 - 개인정보 보호법」에 따라 1년 동안 뮤빗 서비스 이용 기록이 없는 미 이용자 경우 해당
      계정을 휴면계정으로 전환하며, 이용자의 개인정보는 분리보관됩니다.
      <br />
      회사는 휴면계정 이용자에게 유효기간이 도래하기 30일전까지 이용자에게 통지하며 통지내용은 아래와 같습니다.
      <ul>
        <li>통지 내용 : 휴면계정 전환 예정 사실, 개인정보 분리보관 예정일자, 분리 보관되는 개인정보 항목</li>
        <li>통지 대상 : 이메일 가입 이용자</li>
        <li>통지 방법 : 이메일</li>
        <li>통지 날짜 : 휴면계정 전환 30일 전 00 : 00(KST)</li>
      </ul>
      <b>8.4 휴면계정 복구</b>
      <br />
      휴면계정 이용자가 추후 계정 활성화 및 뮤빗 서비스 재 이용 시 분리보관 되었던 개인정보는 복구됩니다.
      <br />
      <br />
      <b>9. 개인정보 보호를 위한 기술 및 관리적 대책</b>
      <br />
      회사는 개인정보 보호를 위해 기술적인 측면과 관리적인 측면에서 다음과같은 조치를 취하고 있습니다.
      <br />
      (1) 개인정보 취급 직원의 최소화 및 교육
      <br />
      개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다.
      <br />
      (2) 정기적인 자체 감사 실시
      <br />
      개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체 감사를 실시하고 있습니다.
      <br />
      (3) 내부관리계획의 수립 및 시행
      <br />
      개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.
      <br />
      (4) 개인정보의 암호화
      <br />
      이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및
      전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.
      <br />
      (5) 해킹 등에 대비한 기술적 대책
      <br />
      해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인
      갱신•점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
      <br />
      (6) 개인정보에 대한 접근 제한
      <br />
      개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여
      필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
      <br />
      (7) 접속기록의 보관 및 위변조 방지
      <br />
      개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지
      않도록 보안기능 사용하고 있습니다.
      <br />
      <br />
      <b>10. 개인정보 보호책임자</b>
      <br />
      회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제 등을
      위하여 아래와 같이 개인정보 보호책임자 및 담당부서를 지정·운영하고 있습니다.
      <ul>
        <li>
          개인정보 보호 책임자
          <br />
          이름 : 손창원 소속/직위 :대표 (주)블렌딩 /대표 이메일 : info@vlending.co.kr 전화: 02-784-8562
        </li>
        <li>
          개인정보 처리 담당자
          <br />
          이름 : 고현운 소속/직위 :이사 (주)블렌딩 /이사 이메일 : support@mubeat.tv 전화 : 02-784-8562
        </li>
      </ul>
      이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및
      담당부서로 문의하실수 있습니다. 회사는 이용자의 문의에 대해 답변 및 처리해드릴 것입니다.
      <br />
      <br />
      <b>11. 개인정보처리방침의 개정</b>
      <br />현 개인정보처리방침의 내용추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 공지사항을 통해 고지할
      것입니다.
      <br />
      <br />
      <b>12. 개인정보 관련 불만사항 및 분쟁의 처리</b>
      <br />
      개인정보 침해를 이유로 피해구제를 받기 원하는 이용자께서는 회사개인정보 관리 책임자 또는 담당자에게 연락해 주세요.
      또는 아래의 기관에서 개인정보 침해에 대한 신고 또는 상담, 피해구제, 분쟁조정 등을 문의하실 수 있습니다.
      <ul>
        <li>
          개인정보 침해신고센터 (한국인터넷진흥원 운영)
          <br />
          소관업무 : 개인정보 침해사실 신고, 상담 신청
          <br />
          홈페이지 : privacy.kisa.or.kr
          <br />
          전화 : (국번없이) 118
          <br />
          주소 : (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층 개인정보침해신고센터
        </li>
        <li>
          개인정보 분쟁조정위원회
          <br />
          소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결) <br />
          홈페이지 : www.kopico.go.kr <br />
          전화 : (국번없이) 1833-6972 <br />
          주소 : (03171)서울특별시 종로구 세종대로 209 정부서울청사 4층 <br />
          대검찰청 사이버범죄수사단 : 02-3480-3573 (www.spo.go.kr) <br />
          경찰청 사이버테러대응센터 : 1566-0112 (www.netan.go.kr)
        </li>
      </ul>
      부칙.
      <br />본 약관은 2021년 09월 30일부터 적용합니다.
    </>
  );
};

export default PrivacyPolicyKO;
